// extracted by mini-css-extract-plugin
export default {"middlePaneWrapper":"MilestoneCreateEdit-module__middlePaneWrapper--gmwp5","milestonePageDescription":"MilestoneCreateEdit-module__milestonePageDescription--mGCls"};